import { createServerFn } from '@tanstack/react-start'
import { getRequestHeaders } from '@tanstack/react-start/server'
import { loadAppSession, loadPublicConfig, loadSessionUser } from '~/server/session.server'

/** Settings the browser needs. Nothing secret: the signup mode and the error-reporting DSN. */
export const getPublicConfig = createServerFn({ method: 'GET' }).handler(async () =>
  loadPublicConfig(),
)

/** The signed-in user, or null. Used by public pages to react to an existing session. */
export const getSessionUser = createServerFn({ method: 'GET' }).handler(async () =>
  loadSessionUser(getRequestHeaders()),
)

/** The signed-in user with their organisations and active role, or null. */
export const getAppSession = createServerFn({ method: 'GET' }).handler(async () =>
  loadAppSession(getRequestHeaders()),
)
